module.exports = __webpack_public_path__ + "img/8.ea63c189.jpg";